/* PROD 
export default [
  {
    Icono: "calendar_today",
    Modulo: "Citas",
    ModuloID: 1,
    Router: "/digitrack/citas",
  },
  {
    Icono: "content_paste",
    Modulo: "Toma de Muestra",
    ModuloID: 2,
    Router: "/digitrack/toma-de-muestra",
  },
  {
    Icono: "mdi-microscope",
    Modulo: "Laboratorio",
    ModuloID: 3,
    Router: "/digitrack/laboratorio",
  },
  {
    Icono: "offline_pin",
    Modulo: "Administración",
    ModuloID: 4,
    Router: "/digitrack/administracion",
  },
  {
    Icono: "approval",
    Modulo: "Certificados",
    ModuloID: 5,
    Router: "/digitrack/certificados",
  },
  {
    Icono: "mdi-file-chart",
    Modulo: "Reportes",
    ModuloID: 6,
    Router: "/digitrack/reportes",
  },
  {
    Icono: "donut_large",
    Modulo: "Analytics",
    ModuloID: 7,
    Router: "/digitrack/analytics",
  },
  {
    Icono: "calendar_today",
    Modulo: "Recepción DAO",
    ModuloID: 8,
    Router: "/digitrack/recepciondao",
  },
  {
    Icono: "mdi-microscope",
    Modulo: "Laboratorio DAO",
    ModuloID: 9,
    Router: "/digitrack/generacion-dao",
  },
  {
    Icono: "approval",
    Modulo: "Sucursal DAO",
    ModuloID: 10,
    Router: "/digitrack/sucursaldao",
  },
];
*/

/* QAS */
export default [
  {
    Icono: "calendar_today",
    Modulo: "Citas",
    ModuloID: 1,
    Router: "/digitrack/citas",
  },
  {
    Icono: "content_paste",
    Modulo: "Toma de Muestra",
    ModuloID: 2,
    Router: "/digitrack/toma-de-muestra",
  },
  {
    Icono: "mdi-microscope",
    Modulo: "Laboratorio",
    ModuloID: 3,
    Router: "/digitrack/laboratorio",
  },
  {
    Icono: "offline_pin",
    Modulo: "Administración",
    ModuloID: 4,
    Router: "/digitrack/administracion",
  },
  {
    Icono: "approval",
    Modulo: "Certificados",
    ModuloID: 5,
    Router: "/digitrack/certificados",
  },
  {
    Icono: "mdi-file-chart",
    Modulo: "Reportes",
    ModuloID: 6,
    Router: "/digitrack/reportes",
  },
  {
    Icono: "donut_large",
    Modulo: "Analytics",
    ModuloID: 7,
    Router: "/digitrack/analytics",
  },
  {
    Icono: "calendar_today",
    Modulo: "Recepción DAO",
    ModuloID: 14,
    Router: "/digitrack/recepciondao",
  },
  {
    Icono: "mdi-microscope",
    Modulo: "Laboratorio DAO",
    ModuloID: 15,
    Router: "/digitrack/generacion-dao",
  },
  {
    Icono: "approval",
    Modulo: "Sucursal DAO",
    ModuloID: 16,
    Router: "/digitrack/sucursaldao",
  },
  {
    Icono: "local_offer",
    Modulo: "Promoción",
    ModuloID: 17,
    Router: "/digitrack/promocion",
  },
];